import { render, staticRenderFns } from "./CustomSelectConfigurator.vue?vue&type=template&id=20381a6d&scoped=true&"
import script from "./CustomSelectConfigurator.vue?vue&type=script&lang=js&"
export * from "./CustomSelectConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectConfigurator.vue?vue&type=style&index=0&id=20381a6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20381a6d",
  null
  
)

export default component.exports